module.exports = __webpack_public_path__ + "img/game-board.13d2fb11.svg";